import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const headerID = 'liveBlogHeader';

const Header = React.forwardRef(({ isLive }, ref) => (
  <div
    id={headerID}
    ref={ref}
    className={classNames(
      styles.wrapper,
      { isLive },
      'b-gray-40 b-solid bw-1px bb-0 bl-0 br-0 mt8 mb6',
    )}
  >
    <h2 className={classNames(styles.header, 'founders-cond f8 lh-none black mt4 mb0')}>
      {i18next.t('Live Blog')}
    </h2>
  </div>
));

Header.propTypes = {
  isLive: PropTypes.bool,
};

Header.defaultProps = {
  isLive: false,
};

export default Header;
